import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-erro-cadastro-lat-lng',
  templateUrl: './erro-cadastro-lat-lng.component.html',
  styleUrls: ['./erro-cadastro-lat-lng.component.scss', '../../styles/estilo.padrao.scss']
})
export class ErroCadastroLatLngComponent implements OnInit {
  arrayIDClientesNome = [];
  sIDPedidos = '';
  displayedColumns: string[] = ['Nome', 'Email', 'Cidade', 'Consultar'];
  clientesSource;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
  ) {
    this.spinner.show('erro-cadastro');
  }

  ngOnInit(): void {
    this.usuarioService.getClientesFalseLatitude().pipe(take(1)).subscribe(snap => {
      if (snap) {

        let dados;
        let auxArrayIDClientesNome = [];
        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (!dados.Latitude || !dados.Longitude) {
            auxArrayIDClientesNome.push({ IDCliente: item.key, Nome: dados.Nome, Cidade: dados.Cidade, Email: dados.Email });
          }
        });

        
        auxArrayIDClientesNome.sort((a, b) => a.Nome.localeCompare(b.Nome));

        this.clientesSource = new MatTableDataSource(auxArrayIDClientesNome);

        setTimeout(() => this.spinner.hide('erro-cadastro'), 300);
      }
    });
  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/validar-estoque"]));
  }

  consultarCliente(dados){
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
    this.router.navigate(["/pages/consultar-cliente"], { queryParams: { IDCliente: dados.IDCliente } }));
  }

}